import React from 'react';

import FormikSelect from 'src/components/formik/FormikSelect';
import { ActionDetail, Step, Table } from 'src/types';
import useGetRequest from 'src/hooks/useGetRequest';
import CRUDConfigForm from 'src/components/formik/CRUDConfigForm';

import { COMPARATOR_OPTIONS } from '../../../constants/otherConstants';
import { FIELD_DETAILS_BY_FIELD_TYPE } from '../../../constants/fieldConstants';
import { WIDGET_DETAILS_BY_WIDGET_TYPE } from '../../../constants/widgetConstants';

interface Props {
  step: Step,
  onSuccess: () => void,
}
const ConditionForm = ({ step, onSuccess }: Props) => {
  const { result: table }: { result: Table, isLoading: boolean } = useGetRequest({
    url: `/automatic/workflows/${step.workflowId}/table/`,
    initialResult: { fields: [] },
  });

  const fieldsConfig = [
    {
      name: 'fieldId',
      component: (_: any, formik: any) => (
        <FormikSelect
          label="Field"
          name="fieldId"
          fullWidth
          options={table.fields.map((field) => ({
            label: field.name,
            value: field.id,
          }))}
          afterChange={() => {
            formik.setFieldValue('value', null);
          }}
        />
      ),
    },
    {
      name: 'comparator',
      component: () => (
        <FormikSelect
          label="Comparator"
          name="comparator"
          fullWidth
          options={COMPARATOR_OPTIONS}
        />
      ),
    },
    {
      name: 'value',
      component: (_: any, formik: any) => {
        const field = table.fields.find((_field) => _field.id.toString() === formik.values.fieldId.toString());

        if (!field) return null;

        const { widgetType } = FIELD_DETAILS_BY_FIELD_TYPE[field.type];
        const Component = WIDGET_DETAILS_BY_WIDGET_TYPE[widgetType].renderer;

        return <Component options={field.options} label="Value" name="value" />;
      },
      shouldRender: (formik: any) => formik.values.fieldId,
    },
  ];

  return (
    <CRUDConfigForm
      url={`/automatic/workflows/${step.workflowId}/conditions/`}
      // @ts-ignore
      objectId={step.action.condition && step.action.condition.id}
      fieldsConfig={fieldsConfig}
      autoSave
      onSuccess={onSuccess}
    />
  );
};

export default ConditionForm;
